let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lw2WF")).then(() => parcelRequire('283Hr'));